import { Controller } from "@hotwired/stimulus"

// Выпадающее меню шапки на узком экране (см. .nav-toggle / .nav-links в
// application.css). На широком экране кнопки-«бургера» нет и контроллер просто
// ничего не делает: открытым/закрытым меню управляет класс, который за
// брейкпоинтом ни на что не влияет.
//
// Закрывается всем, чем ожидает пользователь: Escape, клик мимо, клик по пункту
// (якорные ссылки и «Поддержка» в новой вкладке страницу не меняют, так что
// иначе меню осталось бы висеть) и переход на широкий экран.
export default class extends Controller {
  static targets = ["menu", "toggle"]

  static OPEN_CLASS = "is-open"
  static DESKTOP_QUERY = "(min-width: 821px)"

  connect() {
    // Turbo кэширует страницу как есть и возвращает этот снимок по «назад».
    // Открытое меню в снимке — это открытое меню поверх новой страницы, у
    // которого aria-expanded уже разошёлся с тем, что видно.
    this.beforeCacheHandler = () => this.close()
    document.addEventListener("turbo:before-cache", this.beforeCacheHandler)

    this.desktopQuery = window.matchMedia(this.constructor.DESKTOP_QUERY)
    this.desktopHandler = (event) => {
      if (event.matches) this.close()
    }
    this.desktopQuery.addEventListener("change", this.desktopHandler)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCacheHandler)
    this.desktopQuery.removeEventListener("change", this.desktopHandler)
  }

  toggle(event) {
    if (event) event.preventDefault()
    this.isOpen ? this.close() : this.open()
  }

  open() {
    if (!this.hasMenuTarget) return

    this.menuTarget.classList.add(this.constructor.OPEN_CLASS)
    if (this.hasToggleTarget) this.toggleTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    if (!this.hasMenuTarget) return

    this.menuTarget.classList.remove(this.constructor.OPEN_CLASS)
    if (this.hasToggleTarget) this.toggleTarget.setAttribute("aria-expanded", "false")
  }

  closeOnItemClick(event) {
    if (event.target.closest("a, button")) this.close()
  }

  closeOnOutsideClick(event) {
    if (this.isOpen && !this.element.contains(event.target)) this.close()
  }

  closeOnEscape(event) {
    if (!this.isOpen) return
    if (event.key !== "Escape" && event.key !== "Esc") return

    this.close()
    // Фокус мог остаться на пункте, который сейчас исчезнет из потока.
    if (this.hasToggleTarget) this.toggleTarget.focus()
  }

  get isOpen() {
    return this.hasMenuTarget && this.menuTarget.classList.contains(this.constructor.OPEN_CLASS)
  }
}
